import { useState } from "react";
import { Image, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExpand, faCompress } from "@fortawesome/free-solid-svg-icons";

interface ExpandableImageProps {
  imageUrl: string;
}

const ExpandableImage: React.FC<ExpandableImageProps> = ({ imageUrl }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      className="position-relative d-flex flex-column align-items-center"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Image
        src={imageUrl}
        thumbnail
        className={`transition-all ${isExpanded ? "w-100" : "w-50"}`}
      />

      {isHovered && (
        <Button
          variant="dark"
          className="position-absolute"
          style={{
            top: "10px",
            right: "10px",
            padding: "5px 8px",
            fontSize: "1rem"
          }}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <FontAwesomeIcon icon={isExpanded ? faCompress : faExpand} />
        </Button>
      )}
    </div>
  );
};

export default ExpandableImage;
